import apiService from './api';

export interface CompanyAdmin {
  id: number;
  company_name: string;
  company_email: string;
  company_is_active: boolean;
  admin_id: number | null;
  admin_name: string | null;
  admin_email: string | null;
  admin_role: string | null;
  admin_is_active: boolean | null;
}

export interface ResetPasswordResponse {
  message: string;
  company_name: string;
  admin_name: string;
  admin_email: string;
  new_password: string;
}

const adminService = {
  // Get all companies with their admin information
  async getCompanies(): Promise<CompanyAdmin[]> {
    const response = await apiService.get<CompanyAdmin[]>('/admin/companies');
    return response.data;
  },

  // Reset admin password for a specific company
  async resetAdminPassword(companyId: number): Promise<ResetPasswordResponse> {
    const response = await apiService.post<ResetPasswordResponse>('/admin/reset-admin-password', {
      company_id: companyId
    });
    return response.data;
  }
};

export default adminService; 